import { Box, Typography } from '@mui/material';
import { IconGift } from '@tabler/icons-react';
import formatNumber from 'src/utils/formatNumber';

export const leadPackageCashbackPercent = (packageSize: number) =>
    packageSize >= 200 ? 10 : packageSize >= 100 ? 5 : 0;

export const leadPackageCashbackPoints = (packageSize: number, paidRubles: number) => {
    const paidCents = Math.round(Math.max(0, paidRubles) * 100);
    return Math.floor((paidCents * leadPackageCashbackPercent(packageSize)) / 10000);
};

const pointsLabel = (points: number) => {
    const lastTwo = points % 100;
    const last = points % 10;
    const ending = lastTwo >= 11 && lastTwo <= 14 ? 'баллов' : last === 1 ? 'балл' : last >= 2 && last <= 4 ? 'балла' : 'баллов';
    return `+${formatNumber(points)} ${ending}`;
};

export default function LeadPackageCashback({
    packageSize,
    paidAmount,
    monthlyAmount,
    futureOnly = false,
}: {
    packageSize: number;
    paidAmount: number;
    monthlyAmount?: number;
    futureOnly?: boolean;
}) {
    const percent = leadPackageCashbackPercent(packageSize);
    if (!percent) return null;

    const currentPoints = leadPackageCashbackPoints(packageSize, paidAmount);
    const monthlyPoints = monthlyAmount === undefined ? null : leadPackageCashbackPoints(packageSize, monthlyAmount);
    const rows = futureOnly
        ? [{ label: `Кэшбэк ${percent}% при следующих списаниях`, points: monthlyPoints ?? currentPoints }]
        : monthlyPoints !== null && monthlyPoints !== currentPoints
        ? [
              { label: `Кэшбэк ${percent}% за эту оплату`, points: currentPoints },
              { label: 'При следующих списаниях', points: monthlyPoints },
          ]
        : [{ label: `Кэшбэк ${percent}% после ${monthlyPoints === null ? 'оплаты' : 'каждой оплаты'}`, points: currentPoints }];

    return (
        <Box sx={{ borderTop: '1px solid var(--lm-success-border)', bgcolor: 'var(--lm-success-bg)', color: 'var(--lm-success-ink)', px: 1.5, py: 1 }}>
            {rows.map((row, index) => (
                <Box key={row.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5, py: rows.length > 1 ? 0.35 : 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
                        {index === 0 && <IconGift size={17} stroke={1.8} aria-hidden="true" />}
                        {index > 0 && <Box sx={{ width: 17, flexShrink: 0 }} />}
                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{row.label}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 800, whiteSpace: 'nowrap' }}>{pointsLabel(row.points)}</Typography>
                </Box>
            ))}
        </Box>
    );
}
